import React, { FC, useEffect, useRef } from 'react';
import { renderedData } from '../../../../organisms/SearchResults/searchResultsMainComponent';
import { useHQVContext } from '../../../../context';
import { HQV_ACTIONS } from '../../../../reducers';
import { getHQVSessionData } from '../../../../organisms/SearchResults/lib/helper';
import { HWSBrands } from '../../../../organisms/SearchResults/index.constant';
import { trcRedirectionVarValue } from '../../../../constants';
import clsx from 'clsx';
import { useRedirectionRules, useConditionalPageContextSERP } from '../../../../hooks';
import { useConditionalSearchResultsRenderedDataSERP } from '../../../../hooks/lib/useConditionalRenderedData';
import { addSubDirectoryPrefix } from '../../../../utils/src/helper';
import { NAVIGATION_URL_CONSTANTS } from '../../../../organisms/SearchResults/lib/config';

export const NoImgDiv: FC<{
  propertyID: string;
  brandCode: string;
  clickTrackingLoc: string;
  // eslint-disable-next-line
  imageDimensions: any;
  fallbackImageSrc: string;
  fallbackImagesAlt: string;
  hotelName: string;
  seoNickname?: string;
}> = ({
  propertyID,
  clickTrackingLoc,
  imageDimensions,
  fallbackImageSrc,
  fallbackImagesAlt,
  brandCode,
  hotelName,
  seoNickname,
}) => {
  const { currentLocale, SESSION_GET_CALL_URL_CLIENT, headersData } = useConditionalPageContextSERP();
  const { hqvDispatch, setPropertySessionData, setPropertyID, setModalOpenState } = useHQVContext();
  // eslint-disable-next-line
  const { sessionObject }: any = useConditionalSearchResultsRenderedDataSERP(renderedData);
  const host = headersData?.['x-host'];
  const bodyRef = useRef<HTMLBodyElement | null>(null);

  useEffect(() => {
    bodyRef.current = document.body as HTMLBodyElement;
  }, []);

  const openModal = async (propertyID: string) => {
    const pageNameURL = `${host}${addSubDirectoryPrefix(NAVIGATION_URL_CONSTANTS.SM_HOTEL_QUICK_VIEW_URL)}`;
    const returnedSessionObject = await getHQVSessionData(sessionObject?.sessionID, SESSION_GET_CALL_URL_CLIENT);
    const hqvSessionObject = !returnedSessionObject?.code ? returnedSessionObject : sessionObject;
    // Use direct Zustand methods if available (when feature flag is ON), otherwise use dispatcher
    if (setPropertySessionData && setPropertyID && setModalOpenState) {
      setPropertySessionData(hqvSessionObject);
      setPropertyID(propertyID);
      setModalOpenState(true);
    } else {
      hqvDispatch({ type: HQV_ACTIONS.PROPERTY_SESSION_DATA, payload: hqvSessionObject });
      hqvDispatch({ type: HQV_ACTIONS.PROPERTY_IDENTITY, payload: propertyID });
      hqvDispatch({ type: HQV_ACTIONS.MODAL_OPEN_STATE, payload: true });
    }
    window._satellite['track']('hotelquickview', { pagename: pageNameURL, marsha: propertyID });
    if (bodyRef.current) {
      bodyRef.current.style.height = '100vh';
      bodyRef.current.style.overflow = 'hidden';
    }
  };
  const trcRedirectionURL = useRedirectionRules(
    brandCode,
    propertyID,
    hotelName,
    trcRedirectionVarValue,
    currentLocale,
    seoNickname
  );
  return (
    <div className="no-image-div">
      <div className="property-image">
        {!HWSBrands.includes(brandCode) && (
          <button
            className="hotel-image custom_click_track hqv-modal-opener "
            onClick={() => openModal(propertyID)}
            {...{ custom_click_track_value: `${clickTrackingLoc}| Hotel Image |internal` }}
            tabIndex={-1}
          >
            <img
              className="property-image--img"
              loading="lazy"
              src={fallbackImageSrc}
              height={imageDimensions.height}
              alt={fallbackImagesAlt}
            />
          </button>
        )}
        {HWSBrands.includes(brandCode) && (
          <a
            href={trcRedirectionURL}
            target="_blank"
            rel="noreferrer"
            className={clsx('hotel-image', 'custom_click_track ')}
            {...{ custom_click_track_value: `${clickTrackingLoc}| Reviews |internal` }}
          >
            <img
              className="property-image--img"
              loading="lazy"
              src={fallbackImageSrc}
              height={imageDimensions.height}
              alt={fallbackImagesAlt}
            />
          </a>
        )}
      </div>
    </div>
  );
};
